'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { DONATION_ROUTES } from '@/constants';
import { GOODS_EVENT_LANDING_HREF, GOODS_HOME_IMAGE_URL } from '@/constants/yearEndDonationHome';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { BenefitCard } from '../BenefitCard';
interface StaticBannerProps {
  institutionId: number;
  hasGoodsEventBanner: boolean;
  className?: string;
}
export const BenefitsBanner = t0 => {
  const $ = _c(33);
  const {
    institutionId,
    hasGoodsEventBanner,
    className
  } = t0;
  const {
    entry
  } = useWebviewTypeEntry();
  const [activeIndex, setActiveIndex] = useState(1);
  let t1;
  if ($[0] !== entry || $[1] !== institutionId) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event"]({
      query: {
        institutionId,
        page: 1,
        size: 5,
        excludeEndedYN: true,
        entry
      }
    });
    $[0] = entry;
    $[1] = institutionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1,
      select: _temp
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: data_0
  } = useSuspenseQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Autoplay({
      delay: 5000,
      stopOnInteraction: false
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const autoplayPlugin = t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: true,
      align: "start"
    };
    t5 = [autoplayPlugin];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t4, t5);
  let t6;
  if ($[8] !== emblaApi) {
    t6 = () => {
      if (!emblaApi) {
        return;
      }
      setActiveIndex(emblaApi.selectedScrollSnap() + 1);
    };
    $[8] = emblaApi;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const onSelect = t6;
  let t7;
  let t8;
  if ($[10] !== emblaApi || $[11] !== onSelect) {
    t7 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t8 = [emblaApi, onSelect];
    $[10] = emblaApi;
    $[11] = onSelect;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t9;
  if ($[14] !== hasGoodsEventBanner) {
    t9 = hasGoodsEventBanner ? [{
      key: "goods-event",
      title: "\uC6F0\uB85C \uC5F0\uB9D0 \uD55C\uC815 \uAD7F\uC988 \uC774\uBCA4\uD2B8",
      bannerUrl: GOODS_HOME_IMAGE_URL.HOMETOWN_EVENT_BANNER_MOBILE,
      pcBannerUrl: GOODS_HOME_IMAGE_URL.HOMETOWN_EVENT_BANNER,
      href: GOODS_EVENT_LANDING_HREF
    }] : [];
    $[14] = hasGoodsEventBanner;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== data_0?.contents || $[17] !== t9) {
    t10 = [...t9, ...(data_0?.contents ?? []).map(_temp2)];
    $[16] = data_0?.contents;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const slides = t10;
  if (slides.length === 0) {
    return null;
  }
  let t11;
  if ($[19] !== className) {
    t11 = cn("relative overflow-hidden rounded-small", className);
    $[19] = className;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== activeIndex || $[22] !== slides.length) {
    t12 = slides.length > 1 && <div className="absolute right-12 top-12 z-10 whitespace-nowrap rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">{`${activeIndex} / ${slides.length}`}</div>;
    $[21] = activeIndex;
    $[22] = slides.length;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== slides) {
    t13 = <div className="flex gap-8">{slides.map(_temp3)}</div>;
    $[24] = slides;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== emblaRef || $[27] !== t13) {
    t14 = <div className="relative overflow-hidden" ref={emblaRef}>{t13}</div>;
    $[26] = emblaRef;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t14) {
    t15 = <section className={t11}>{t12}{t14}</section>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
function _temp(data) {
  return data.context;
}
function _temp2(item) {
  return {
    key: String(item.eventId),
    title: item.title,
    bannerUrl: item.bannerImageUrl,
    pcBannerUrl: item.pcBannerImageUrl,
    href: DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
      eventId: item.eventId
    })
  };
}
function _temp3(t0) {
  const {
    key,
    ...slide
  } = t0;
  return <div key={key} className="min-w-0 flex-[0_0_100%]"><BenefitCard {...slide} /></div>;
}